import { FC } from 'react';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Faq } from '@/types/dto/Faq';

type TableRow = Faq;

type FaqTableProps = {
  rows: TableRow[];
  selectable?: boolean;
  onSelectedChange?: (selectedElements: number[]) => void;
  onRowClick?: (selectedElementId: number) => void;
};

const FaqTable: FC<PropsWithClassName<FaqTableProps>> = ({
  rows,
  className,
  onSelectedChange,
  selectable = false,
  onRowClick,
}) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'restaurant', headerName: t('tableLabel.restaurant'), width: 200 },
    { field: 'question', headerName: t('tableLabel.question'), width: 250 },
    { field: 'answer', headerName: t('tableLabel.answer'), width: 350 },
    {
      field: 'created_at',
      headerName: t('tableLabel.created_at'),
      width: 200,
      cellClassName: 'flex items-center',
      renderCell: (params) => dayjs(params.row.created_at).format('h:mm a | MM/DD/YY'),
    },
    { field: 'question_id', headerName: t('tableLabel.question_id'), width: 100 },
    { field: 'answer_id', headerName: t('tableLabel.answer_id'), width: 100 },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  return (
    <Paper sx={{ width: '100%' }} className={className}>
      <DataGrid
        getRowId={(row) => row.question_id}
        rows={rows}
        columns={columns}
        checkboxSelection={selectable}
        onRowSelectionModelChange={(selectedIds: GridRowSelectionModel) => {
          if (onSelectedChange) {
            onSelectedChange(selectedIds.map((id) => id as number) ?? []);
          }
        }}
        disableMultipleRowSelection={true}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 20, 50, 100]}
        rowSelection={selectable}
        disableRowSelectionOnClick={false}
        onRowClick={(params) => (onRowClick ? onRowClick(params.id as number) : null)}
      />
    </Paper>
  );
};

export default FaqTable;
